import clsx from 'clsx';
import styles from './Card.module.css';
import { LFC } from '../../types';

interface CardHeaderProps {
  className?: string;
}

export const CardHeader: LFC<CardHeaderProps> = ({ children, className }) => {
  return <div className={clsx(styles.header, className)}>{children}</div>;
};
